import React from 'react';
import axios from 'axios';
import qs from 'qs';

const Form = ({ pageTitle, pageItem, accessor }: any) => {
  // ...
  const [input, setInput] = React.useState('');
  // ...
  const [message, setMessage] = React.useState({
    handleClicked: false,
    containError: false,
    message: '',
    waiting: false,
  });

  // ...
  function handleClick(e: any) {
    // ...
    e.preventDefault();
    // ...
    const data: { [index: string]: any } = {}
    // ...
    accessor === 'capacity' || accessor === 'anoColheita'
      ? (data[pageItem] = { [accessor]: +input })
      : (data[pageItem] = { title: input });
    // ...
    setMessage({ handleClicked: true, containError: false, message: '', waiting: true });
    // ...
    if (input === '') {
      setMessage({
        handleClicked: true,
        containError: true,
        message: `Campo não pode ser vazio`,
        waiting: false,
      });
    } else {
      console.log(`${process.env.REACT_APP_API_URL}${pageTitle}`)
      console.log(data)
      axios
        .post(`${process.env.REACT_APP_API_URL}${pageTitle}`, qs.parse(data))
        .then((response) => {
          setMessage({
            handleClicked: true,
            containError: false,
            message: `Item created`,
            waiting: false,
          });
          console.log(response.data);
          setInput('');
        })
        .catch((error) => {
          return setMessage({
            handleClicked: true,
            containError: true,
            message: `${error.message}`,
            waiting: false,
          });
        });
    }
  }

  return (
    <>
      {/* Form Create New Category */}
      <form className="intro-y form-data w-full flex p-8 items-center"     >
        {(accessor === 'capacity' || accessor === 'anoColheita')
          ? (<input
            className="bg-dark-2 text-white rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 p-2 shadow-md"
            value={input}
            type="number" step="0.1"
            onChange={(e) => {
              setInput(e.target.value);
            }}
          />)
          :
          (<input
            className="bg-dark-2 text-white rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 p-2 shadow-md"
            value={input}
            onChange={(e) => {
              setInput(e.target.value);
            }}
          />)
        }
        <button
          onClick={handleClick}
          className="px-4 py-2 m-2 bg-dark-2 rounded-md shadow-md"
        >
          ADICIONAR
        </button>
      </form>
      {/* If Error... */}
      {message.handleClicked === true &&
        (message.waiting === true ? (
          <span style={{ color: '#fffff' }}>Carregando...</span>
        ) : (
          <div style={{ color: message.containError ? '#ff5151' : '#35c823' }}>
            {message.message}
          </div>
        ))}
    </>
  );
};

export default Form;

